import { Button } from "PFComponents/button";
import { CustomValue } from "PFTypes";
import React from "react";

import { useSkillManagementSidePanel } from "../hooks/use_skill_management_side_panel";

type SkillTitleProps = {
  skill: CustomValue;
};

export const SkillTitleButton = ({ skill }: SkillTitleProps) => {
  const { openSidePanel } = useSkillManagementSidePanel();

  return <Button text={String(skill.value)} kind="text" onClick={() => openSidePanel(skill.id)} />;
};
